import { render, staticRenderFns } from "./Loan.vue?vue&type=template&id=b99d5f42&scoped=true"
import script from "./Loan.vue?vue&type=script&lang=js"
export * from "./Loan.vue?vue&type=script&lang=js"
import style0 from "./Loan.vue?vue&type=style&index=0&id=b99d5f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99d5f42",
  null
  
)

export default component.exports